import React, { useState, useRef } from "react";
import { apiCall } from "../utils/Api";
import { AutoComplete, Col, Row, Input, Select, Button } from "antd";
import { useHistory } from "react-router-dom";
import { CaretRightOutlined, SearchOutlined } from '@ant-design/icons';
import Cookies from "js-cookie";
import { getTitleImagePath } from "../utils/Utils";
const { Search } = Input;
const { Option } = Select;
export default function SearchSuggest(props) {


    const { searchType = "" } = props;
    const ref = useRef(0);
    const history = useHistory();
    const [options, setOptions] = useState([])
    const [term, setTerm] = useState("");

    const debounceRef = useRef(null);

    function getSortValueFromUrl(url, defaultValue = '') {
        const match = url.match(/\/v\/([^\/]+)/);
        return match ? decodeURIComponent(match[1]) : defaultValue;
    }

    const sort = getSortValueFromUrl(history.location.pathname);


    const onSearch = () => {

    }

    const drawPlaceholder = (_type) => {
        // const searchCategories = ["Keyword", "Title", "Author", "Publisher", "URL", "File"];


        switch (_type) {

            case "title":
                return "exact title";

            case "author":
                return "author";

            case "publisher":
                return "publisher";

            case "url":
                return "URL";

            case "file":
                return "file";

            case "keyword":
            default:
                return "title, author, subject, or ISBN";


        }
    }

    const getSuggestions = (_t) => {

        if (!_t) {
            setTerm("");
            setOptions([]);
            return;
        }
        apiCall("browse/getSuggest", { t: _t, l: 5, k: searchType, v: sort }, (_status, _result) => {
            if (_status) {

                if (_result?.length === 1) {
                    setOptions([])
                } else {
                    setOptions(_result)
                }

            }
        })
    }

    const handleSearch = (_t) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(() => {
            getSuggestions(_t);
        }, 650);
    };

    const linkOut = (_eisbn) => {
        props.onSearch(_eisbn, true, false, "keyword");
        // history.push("/item/" + _eisbn);
    }

    const handleKeyDown = (ev) => {
        if (ev.keyCode === 27) {
            ev.preventDefault();
        }
    }


    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <AutoComplete
                disabled={(searchType === "file")}
                size="small"
                open={isOpen}
                aria-label="Search by title, author, subject or ISBN"
                onKeyDown={handleKeyDown}
                notFoundContent={(term) ? <>No suggesstions found...</> : null}
                onClear={() => setTerm("")}
                onSearch={(e) => handleSearch(e)}
                onSelect={(e) => linkOut(e)}
                options={options.map(item => {
                   
                    const _path = getTitleImagePath(item?.eisbn, item?.cover_image_cache, 0, "small");
                    return {
                        value: item.isbn,
                        label: <>


                            <Row wrap={false} gutter={10}>
                                <Col flex={"25px"}>
                                    <img onError={(e) => e.target.src = "https://cdn1.bookmanager.com/i/nocover.png"} style={{ "width": "25px" }} src={_path} alt={item.title} />
                                </Col>
                                <Col flex={"auto"}>
                                    <div style={{ "display": "flex", "justifyContent": "space-between", "alignItems": "center" }}>
                                        <div style={{ "lineHeight": "15px", "paddingLeft": "10px", "maxWidth": "420px", "overflow": "hidden" }}>
                                            <div style={{ "overflow": "hidden", "textOverflow": "ellipsis", "width": "400px" }}>{item.title}</div>
                                            <div style={{ "overflow": "hidden", "textOverflow": "ellipsis", "width": "400px" }}><small>{item.subtitle}</small></div>
                                            <div style={{ "overflow": "hidden", "textOverflow": "ellipsis", "width": "400px" }}><small><em>{item.author}</em></small></div>
                                        </div>
                                        <div><CaretRightOutlined /></div>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    }
                })}

                style={{ "width": "100%", "maxWidth": "500px", "height": "32px", "border": "none" }} className="header_search tab" id="search" >


                <Input.Search onFocus={() => setIsOpen(true)} onClick={() => setIsOpen(true)} onBlur={() => setIsOpen(false)} value={props.keyword} addonBefore={<div onMouseOver={() => setIsOpen(false)}>{props.addonBefore}</div>} suffix={props.suffix} onChange={props.onChange} onSearch={(e) => {
                    if (debounceRef.current) {
                        clearTimeout(debounceRef.current);
                    }
                    props.onSearch(e, true, true)
                }} className="clean-input" allowClear enterButton placeholder="Keywords, author or title..." style={{ "minWidth": "100px", "maxWidth": "450px" }} />

                {/* <Search addonBefore={props.addonBefore} ref={ref} style={{ "maxWidth": "100%", "border": "none" }} className={"clean-input"} size={"small"} aria-label="Search by title, author, subject or ISBN" onSearch={(_value, e) => onSearch(_value, e)} placeholder={"Search by " + drawPlaceholder(searchType)} size="large" /> */}
            </AutoComplete>
        </>
    )
}